import React from 'react';
import { Modal, Button, Flex, Typography, theme } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';

export default function LogoutConfirmModal({
  open,
  onCancel,
  onConfirm,
  confirming = false,
  isDarkMode = false,
}) {
  const { token } = theme.useToken();

  const iconWrapStyle = {
    width: 52,
    height: 52,
    borderRadius: 14,
    background: `linear-gradient(135deg, ${token.colorPrimary} 0%, ${token.colorPrimaryHover} 100%)`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: token.colorTextLightSolid,
    fontSize: 24,
    flexShrink: 0,
    boxShadow: isDarkMode
      ? '0 10px 24px rgba(255, 113, 0, 0.28)'
      : '0 8px 20px rgba(255, 113, 0, 0.22)',
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      width={400}
      destroyOnHidden
      className="logout-confirm-modal"
      styles={{
        mask: {
          backdropFilter: 'blur(8px)',
          background: isDarkMode ? 'rgba(0, 0, 0, 0.72)' : 'rgba(15, 23, 42, 0.48)',
        },
        content: {
          padding: 0,
          borderRadius: 20,
          overflow: 'hidden',
          background: token.colorBgContainer,
          border: `1px solid ${token.colorBorderSecondary}`,
          boxShadow: isDarkMode
            ? '0 24px 64px rgba(0, 0, 0, 0.55)'
            : '0 24px 64px rgba(0, 0, 0, 0.14)',
        },
        body: { padding: 0 },
      }}
    >
      <div
        style={{
          background: `linear-gradient(135deg, ${token.colorPrimaryBg} 0%, ${token.colorBgContainer} 72%)`,
          padding: '24px 28px 20px',
          borderBottom: `1px solid ${token.colorBorderSecondary}`,
        }}
      >
        <Flex align="center" gap={16}>
          <div style={iconWrapStyle}>
            <LogoutOutlined />
          </div>
          <Flex vertical gap={4}>
            <Typography.Text
              strong
              style={{
                fontSize: 20,
                letterSpacing: '-0.02em',
                color: token.colorText,
                lineHeight: 1.25,
              }}
            >
              Log out of MOGU?
            </Typography.Text>
            <Typography.Text
              style={{
                fontSize: 13,
                color: token.colorTextSecondary,
                lineHeight: 1.45,
              }}
            >
              You will need to sign in again to continue.
            </Typography.Text>
          </Flex>
        </Flex>
      </div>

      <Flex
        vertical
        gap={20}
        style={{
          padding: '24px 28px 28px',
          background: token.colorBgContainer,
        }}
      >
        <Typography.Paragraph
          style={{
            margin: 0,
            fontSize: 14,
            lineHeight: 1.6,
            color: token.colorTextSecondary,
            textAlign: 'center',
          }}
        >
          Any unsaved changes may be lost. Are you sure you want to end your session?
        </Typography.Paragraph>

        <Flex gap={12} justify="center">
          <Button
            size="large"
            onClick={onCancel}
            disabled={confirming}
            style={{
              minWidth: 112,
              borderRadius: 999,
              fontWeight: 600,
            }}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            size="large"
            loading={confirming}
            onClick={onConfirm}
            icon={<LogoutOutlined />}
            style={{
              minWidth: 128,
              borderRadius: 999,
              fontWeight: 600,
              boxShadow: isDarkMode
                ? '0 6px 16px rgba(255, 113, 0, 0.3)'
                : '0 6px 16px rgba(255, 113, 0, 0.22)',
            }}
          >
            Log out
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
}
